import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import styled, { css, withTheme } from 'styled-components'
import HeaderDetailArticle from './components/HeaderDetailArticle'
import ContainerArticle from '../../../../components/ContainerArticle'
import ModifyAndShareDetailArticle from './components/ModifyAndShareDetailArticle'
import WidgetRelated from '../../widgets_line/WidgetRelated'
import ContainerAd from '../../../../components/ContainerAd'
import Breadcrumb from '../../../../components/Breadcrumb'
import Map from '../../../../components/Map'
import ContentDetailArticle from './components/ContentDetailArticle'
import ImageDetailArticle from './components/ImageDetailArticle'
import VideoDetailArticle from './components/VideoDetailArticle'
import hasItems from '../../../../modules/has-items'
import CommentsDetailArticle from './components/CommentsDetailArticle'
import isStolApp from '../../../../modules/is-stolapp'
import Outbrain from '../../../../vendor/AdThirdParty/components/Outbrain'
import DistrictsNav from '../../../../components/DistrictsNav'
import { setStoredItem } from '../../../../modules/stored-item'
import { withRouter } from 'react-router-dom'
import { setFont, getFont, translateFontSizeToTheme } from '../../../../modules/font'
import appBottomPadding, { iPhoneXPadding } from '../../../../modules/mixins/app-bottom-padding'
import checkForValueInUserAgent from '../../../../modules/check-for-value-in-useragent'
import CloudTag from './components/CloudTag'
import Icon from '../../../../components/Icon'
import AuthorInfo from './components/AuthorInfo'

const StyledContainerAd = styled(ContainerAd)`
  margin: 25px 0;
  padding-bottom: 25px;
`
const StyledHeaderDetailArticle = css`
  margin-top: 20px;
  margin-bottom: 40px;
  margin-left: -40px;
  width: calc(100% + 80px);
`

const StyledImageDetailArticle = styled(ImageDetailArticle)`
  ${StyledHeaderDetailArticle}
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    width: calc(100% + (2 * ${(props) => props.theme.mobile.sizes.gapEdge}));
    margin-left: -${(props) => props.theme.mobile.sizes.gapEdge};
    margin-right: -${(props) => props.theme.mobile.sizes.gapEdge};
  }
`

const StyledVideoDetailArticle = styled(VideoDetailArticle)`
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    ${StyledHeaderDetailArticle}
    @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
      margin-bottom: ${(props) => props.theme.mobile.sizes.gapEdge};
      margin-left: -${(props) => props.theme.mobile.sizes.gapEdge};
      width: calc(100% + (2 * ${(props) => props.theme.mobile.sizes.gapEdge}));
    }
  }
`

const StyledEditor = styled.p`
  font-family: ${(props) => props.theme.font.primary};
  font-size: calc(${(props) => props.fontSize} - 3px);
  color: ${(props) => props.theme.color.textSecondary};
`
const StyledContainerArticle = styled(ContainerArticle)`
  margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
`

const StyledAuthorInfo = styled(AuthorInfo)`
  //margin-top: -20px;
  //margin-bottom: 20px;
`

//moved inline css to this component
const Wrapper = styled.div`
  background-color: ${(props) => props.backgroundColor};
  margin-bottom: ${(props) => props.theme.sizes.gapVertical};
  @media (max-width: ${(props) => props.theme.tablet.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.tablet.sizes.gapVertical};
  }
  @media (max-width: ${(props) => props.theme.mobile.breakPoint + 'px'}) {
    margin-bottom: ${(props) => props.theme.mobile.sizes.gapVertical};
  }
  //inline css
  .attribute-image > img {
    max-width: 100%;
  }
  .img-inline {
    text-align: center;
  }
  .img-inline > a:nth-child(2) > i > svg {
    display: none;
  }

  .img-inline {
    a {
      line-break: anywhere;
    }
  }
  .uk-img-preserve {
    max-width: 220px;
    box-shadow: 2px 2px 5px 0px rgba(0, 0, 0, 0.3);
    width: 100%;
  }
  iframe {
    border: none;
  }
  ${(props) => props.isStolApp && appBottomPadding};
  ${(props) => props.isIphoneX && iPhoneXPadding};
`

const WrapperUnderDistrictNav = styled.div`
  background-color: #fff;
`

class DetailArticle extends Component {
  constructor(props) {
    super(props)
    this.state = {
      fontSize: getFont(),
      backgroundColor: null,
    }
    this.reduceFont = this.reduceFont.bind(this)
    this.enlargeFont = this.enlargeFont.bind(this)
  }

  enlargeFont() {
    let newFont = setFont(this.state.fontSize, '+', () =>
      setStoredItem('fontSize ' + this.props.location.pathname, (this.state.fontSize + 1).toString(), true),
    )
    if (newFont !== this.state.fontSize)
      this.setState({
        fontSize: newFont,
      })
  }

  reduceFont() {
    let newFont = setFont(this.state.fontSize, '-', () =>
      setStoredItem('fontSize ' + this.props.location.pathname, (this.state.fontSize - 1).toString(), true),
    )
    if (newFont !== this.state.fontSize) {
      this.setState({
        fontSize: newFont,
      })
    }
  }

  render() {
    const { data, adTargeting, location, ...props } = this.props
    const headmedia = {
      local: data.local,
      type: data.type,
      partner: data.partner,
      image: data.image,
    }
    let breadcrumb = []
    breadcrumb.push(data.breadcrumb.department)
    hasItems(data.breadcrumb.subDepartment) && breadcrumb.push(data.breadcrumb.subDepartment)
    const isCondulence = data.articleLayout === 'condulence'
    const isSportnews = data.partner === 'sportnews'
    const plus = data.plus && !isSportnews

    const articleLayout = data.articleLayout ? data.articleLayout : data.partner
    if (data && data.articleLayout && data.articleLayout === 'pr') {
      if (this.state.backgroundColor !== props.theme.color.pr) {
        this.setState({
          backgroundColor: props.theme.color.pr,
        })
      }
    }

    return (
      <Wrapper
        backgroundColor={this.state.backgroundColor}
        isStolApp={isStolApp()}
        isIphoneX={checkForValueInUserAgent('iphonex')}
        {...props}
      >
        {!isStolApp() && <Breadcrumb bookmark={{ show: true, state: false }} crumbs={breadcrumb} />}

        <StyledContainerArticle>
          <HeaderDetailArticle
            title={data.title}
            headline={data.breadcrumb.headline}
            date={data.date}
            description={data.description}
            plus={data.plus}
            fontSize={translateFontSizeToTheme(this.state.fontSize, props.theme.fontSize.text)}
          />

          {!isStolApp() && (
            <ModifyAndShareDetailArticle
              position="top"
              enlargeFontCallBack={this.enlargeFont}
              reduceFontCallBack={this.reduceFont}
            />
          )}
          {data && data.image && data.image.url && (!data.video || data.video.length === 0) && (
            <StyledImageDetailArticle fontSize={this.state.fontSize} {...headmedia} />
          )}
          {data && data.image && data.image.url && data.video && (
            <StyledVideoDetailArticle
              fontSize={this.state.fontSize}
              plus={plus}
              inHeader
              video={data.video}
              showAds={data.showAds}
              copyright={data.video.copyright}
              adTargeting={adTargeting}
              {...headmedia}
            />
          )}

          {data.author != null && <StyledAuthorInfo author={data.author}></StyledAuthorInfo>}

          {!isCondulence && (
            <Fragment>
              <ContentDetailArticle
                htmlContent={data.content}
                plus={plus}
                plusTeaser={data.sPlusTeaser}
                plusContent={data.sPlusContent}
                embeds={data.embeds}
                showAds={data.showAds}
                fontSize={translateFontSizeToTheme(this.state.fontSize, props.theme.fontSize.text)}
                notTranslatedFontSize={this.state.fontSize}
                adId="S5"
                adTargeting={adTargeting}
                articleLayout={articleLayout}
              />
              {data.editor && !isSportnews && (
                <StyledEditor fontSize={translateFontSizeToTheme(this.state.fontSize, props.theme.fontSize.text)}>
                  {data.editor}
                </StyledEditor>
              )}
              {data.tags && <CloudTag tags={data.tags} />}
            </Fragment>
          )}
        </StyledContainerArticle>

        {!isCondulence && data.showAds && <StyledContainerAd adIds={['S3', 'S4']} />}
        <WrapperUnderDistrictNav>
          {data.geo && <Map lat={data.geo.lat} lng={data.geo.lng} height={300} />}
          {hasItems(data.districts) && <DistrictsNav selected={data.districts} open />}
          {hasItems(data.related) && <WidgetRelated articles={data.related} />}
          {data.showAds && <Outbrain location={location} />}
          <StyledContainerArticle>
            <CommentsDetailArticle
              articleId={data.id}
              comments={data && data.comments}
              commentsEnabled={data.commentsEnabled && !isSportnews}
              isCondulence={isCondulence}
              plus={plus}
            />
          </StyledContainerArticle>
        </WrapperUnderDistrictNav>
      </Wrapper>
    )
  }
}

DetailArticle.propTypes = {
  data: PropTypes.shape({
    breadcrumb: PropTypes.arrayOf({
      name: PropTypes.string,
      route: PropTypes.string,
    }),
    ...HeaderDetailArticle.propTypes,
    ...WidgetRelated.propTypes,
  }),
}

export default withRouter(withTheme(DetailArticle))

export {
  StyledContainerArticle as StyledContainerArticle0DetailArticle,
  StyledImageDetailArticle as StyledImageDetailArticle0DetailArticle,
}
